import * as React from 'react';
import { Popover } from 'antd';
import FIcons from '@/components/FIcons';
import styles from './index.less';
import type { Option } from './types';

interface CascaderMenuProps {
  options: Option[];
  zIndex?: number;
  onSelect: (op: Option) => void;
  getPopupContainer?: () => HTMLElement;
}

function CascaderMenuItem({
  option,
  zIndex,
  onSelect,
  getPopupContainer,
}: {
  option: Option;
  zIndex: number;
  onSelect: (op: Option) => void;
  getPopupContainer?: () => HTMLElement;
}) {
  const parentContentRef = React.useRef<HTMLDivElement>(null);
  const hasChildren = option.children.length > 0;

  const itemContent = (
    <div
      className={styles.item}
      onClick={() => {
        if (!hasChildren) {
          onSelect(option);
        }
      }}
    >
      <span>{option.label}</span>
      {hasChildren && <FIcons.FRight className={styles.itemRightIcon} />}
    </div>
  );

  if (!hasChildren) {
    return itemContent;
  }

  return (
    <Popover
      arrow={false}
      align={{ offset: [5, 0] }}
      zIndex={zIndex}
      open={undefined}
      getPopupContainer={getPopupContainer}
      overlayClassName={styles.PopoverOverlayClassName}
      title={null}
      placement="rightTop"
      content={
        <div ref={parentContentRef} className={styles.itemChildren}>
          <CascaderMenu
            options={option.children}
            zIndex={zIndex + 1}
            onSelect={onSelect}
            getPopupContainer={() =>
              parentContentRef.current || getPopupContainer?.() || document.body
            }
          />
        </div>
      }
    >
      {itemContent}
    </Popover>
  );
}

function CascaderMenu({
  options,
  zIndex = 10000,
  onSelect,
  getPopupContainer,
}: CascaderMenuProps) {
  return (
    <>
      {options.map((option) => (
        <React.Fragment key={option.value}>
          <CascaderMenuItem
            option={option}
            zIndex={zIndex}
            onSelect={onSelect}
            getPopupContainer={getPopupContainer}
          />
        </React.Fragment>
      ))}
    </>
  );
}

export default CascaderMenu;
